"use client";
import Image from "next/image";
import { useTranslations } from "next-intl";

export const BuiltByBar = () => {
  const t = useTranslations("builtBy");

  return (
    <section className="relative w-full py-20 md:py-28">
      <div className="relative mx-auto max-w-5xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-center">
          {/* Founder portrait */}
          <div className="flex justify-center md:justify-start">
            <div className="relative">
              <div
                className="absolute -inset-2 rounded-full opacity-50 blur-2xl"
                style={{
                  background:
                    "radial-gradient(circle, rgba(239,68,68,0.45), transparent 70%)",
                }}
                aria-hidden
              />
              <Image
                src="/founder-till.webp"
                alt={t("founder_name")}
                width={256}
                height={256}
                className="relative h-44 w-44 md:h-64 md:w-64 rounded-full object-cover ring-2 ring-red-500/40 shadow-[0_0_40px_rgba(239,68,68,0.25)]"
              />
            </div>
          </div>

          {/* Text */}
          <div className="text-center md:text-left">
            <h2 className="text-2xl md:text-4xl font-bold leading-tight text-white tracking-tight">
              {t("headline")}
            </h2>

            <p className="mt-4 text-sm md:text-base text-neutral-400 leading-relaxed max-w-2xl">
              {t("bio")}
            </p>

            <div className="mt-6 flex flex-col md:flex-row md:items-center gap-2 md:gap-4 text-sm">
              <span className="font-medium text-white">{t("founder_name")}</span>
              <span className="hidden md:inline text-neutral-700">·</span>
              <span className="text-neutral-500">{t("founder_role")}</span>
            </div>

            <p className="mt-3 text-xs text-neutral-500 italic">
              {t("co_shaped")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
